<template>
  <div class="TeamPage content inner-grid-container">
    <div class="banner">
      <Banner class="fancyHeading" v-bind:text="team1.name + ' vs ' + team2.name"></Banner>
    </div>
    <div class="team-stats team-stats1">
      <TeamStatsCard  v-if="!(team1 == 'unknown')" v-bind:team="team1"></TeamStatsCard>
    </div>
    <div class="team-stats team-stats2">
      <TeamStatsCard v-if="!(team2 == 'unknown')" v-bind:team="team2"></TeamStatsCard>
    </div> 
    <div v-if="!(team1 == 'unknown')" class="players-team1">
        <PlayerCard v-for="player in team1.players" :key="player.name" v-bind:player="player" v-bind:teamId="team1.id"></PlayerCard>
    </div>
    <div v-if="!(team2 == 'unknown')" class="players-team2">
        <PlayerCard v-for="player in team2.players" :key="player.name" v-bind:player="player" v-bind:teamId="team2.id"></PlayerCard>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import TeamStatsCard from "@/components/TeamStatsCard.vue";
import PlayerCard from "@/components/PlayerCard.vue";
export default {
  name: "TeamComparison",

  components: {
    Banner,
    TeamStatsCard,
    PlayerCard
  },
  computed: {
    team1() {
      if (this.$route.params.team1Id == "unknown") {
        return "unknown"
      } else {
        return this.$store.getters.team(this.$route.params.team1Id)
      }
    },
    team2() {
      if (this.$route.params.team2Id == "unknown") {
        return "unknown"
      } else {
        return this.$store.getters.team(this.$route.params.team2Id)
      }
    }
  }
};
</script>

<style scoped>
.inner-grid-container {
  display: grid;
  grid-column-gap: 30px;
  grid-template-columns: auto 500px 500px auto;
  grid-template-areas:
    'banner banner banner banner'
    'leftleftTop leftTop rightTop rightrightTop'
    'leftleftBot leftBot rightBot rightrightBot';
  grid-row-gap: 25px;
}

.team-stats1{
  grid-area: leftTop;
}

.team-stats2{
  grid-area: rightTop;
}

.players-team1 {
  grid-area: leftBot;
}

.players-team2 {
  grid-area: rightBot;
}

@media (max-width: 600px) {
  .inner-grid-container {
    grid-template-columns: auto auto auto auto;
    grid-column-gap: 0px;
    grid-template-areas:
    'banner banner banner banner'
    'leftTop leftTop leftTop leftTop'
    'leftBot leftBot leftBot leftBot' 
    'rightTop rightTop rightTop rightTop' 
    'rightBot rightBot rightBot rightBot';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TeamComparison.vue